import { useState, useEffect } from "react"
import ErrorMessage from "components/forms/error-message"
import _ from "lodash"
import Label from "components/forms/label"
import Input from "components/forms/input"
import { lang } from "config"
import useBranches from "repositories/branch"

const Form = ({ data = {}, errors = {}, onSubmit }) => {
    const id = data.id ?? undefined
    const isEdit = Boolean(id)

    const [branchId, setBranchId] = useState(data.branch_id ?? "")
    const [name, setName] = useState(data.name ?? "")
    const [pin, setPin] = useState("")
    const [isActive, setIsActive] = useState(
        data.is_active !== undefined && data.is_active !== null ? String(data.is_active) : "1"
    )

    const { data: branches, isLoading: branchesLoading } = useBranches({
        paginate: false
    })

    useEffect(() => {
        setBranchId(data.branch_id ?? "")
        setName(data.name ?? "")
        setPin("")
        setIsActive(
            data.is_active !== undefined && data.is_active !== null ? String(data.is_active) : "1"
        )
    }, [data?.id])

    const handleSubmit = (e) => {
        e.preventDefault()

        onSubmit({
            id,
            branch_id: branchId,
            name,
            pin,
            is_active: Number(isActive),
        })
    }

    return (
        <form onSubmit={handleSubmit} className="mt-8 space-y-8">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                    <Label htmlFor="branch_id" value={lang.branch} />
                    <select
                        id="branch_id"
                        value={branchId}
                        onChange={(e) => setBranchId(e.target.value)}
                        className={`${
                            errors.branch_id ? "border-red-200" : "border-neutral-200"
                        } w-full px-4 py-3 mt-1 text-sm transition border rounded-xl focus:outline-none focus:border-neutral-400 focus:ring focus:ring-neutral-200`}
                    >
                        <option value="">
                            {branchesLoading ? "Loading branches..." : `Select ${lang.branch}`}
                        </option>

                        {(branches ?? []).map((branch) => (
                            <option key={branch.id} value={branch.id}>
                                {branch.name}
                            </option>
                        ))}
                    </select>
                    <ErrorMessage error={errors.branch_id} />
                </div>

                <div>
                    <Label htmlFor="name" value="Cashier Name" />
                    <Input
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        error={errors.name}
                    />
                    <ErrorMessage error={errors.name} />
                </div>

                <div>
                    <Label
                        htmlFor="pin"
                        value={isEdit ? "New PIN (optional)" : "PIN"}
                    />
                    <Input
                        id="pin"
                        value={pin}
                        onChange={(e) => setPin(e.target.value)}
                        error={errors.pin}
                        maxLength={6}
                        type="password"
                        placeholder={isEdit ? "Leave blank if unchanged" : "Enter 6-digit PIN"}
                    />
                    <ErrorMessage error={errors.pin} />
                </div>

                <div>
                    <Label htmlFor="is_active" value="Status" />
                    <select
                        id="is_active"
                        value={isActive}
                        onChange={(e) => setIsActive(e.target.value)}
                        className={`${
                            errors.is_active ? "border-red-200" : "border-neutral-200"
                        } w-full px-4 py-3 mt-1 text-sm transition border rounded-xl focus:outline-none focus:border-neutral-400 focus:ring focus:ring-neutral-200`}
                    >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                    </select>
                    <ErrorMessage error={errors.is_active} />
                </div>
            </div>

            <div className="text-xs">
                <button
                    type="submit"
                    className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90"
                >
                    <span>{`${_.isEmpty(data) ? lang.create : lang.update}`}</span>
                </button>
            </div>
        </form>
    )
}

export default Form